<template>
  <lazy-component wrapper-tag="span">
    <a-avatar icon="user" :src="avatarUri" v-bind:size="size"></a-avatar>
    <span slot="placeholder">
      <a-avatar icon="user" v-bind:size="size"></a-avatar>
    </span>
  </lazy-component>
</template>

<script>
export default {
  name: 'CustomerAvatarComponent',
  props: {
    customerId: {
      type: [String, Number],
      required: false
    },
    size: {
      type: [String, Number],
      default: 'default',
    },
  },
  computed: {
    avatarUri () {
      return '/customer/' + this.customerId + '/avatar'
    },
  }
}
</script>

<style scoped>
.ant-avatar svg {
  height: 30px;
}
</style>
